var eventToolbox = require('src/interlock/no-ui/utils/event-toolbox/event-toolbox'),


    constants = require('src/interlock/no-ui/constant/carousel');

eventToolbox.subscribeCustomEvent(constants.OWL_CAROUSEL_SWIPE_EVENT_NAME, function (event, creativeId, data) {
    function getActionAndSubActionName(){
        var actions = {
            'action_name':'view_content'
        };
        var owlCarousel = $('#'+creativeId+' .owl-carousel');
        if (owlCarousel && owlCarousel.length > 0) {
            var carouselOptions = owlCarousel.data('carousel-options');
            if(carouselOptions){
                actions.action_name = carouselOptions.action_name ? carouselOptions.action_name : actions.action_name;
                actions.subaction_name = carouselOptions.subaction_name;
                actions.action_cause = carouselOptions.action_cause ? carouselOptions.action_cause : 'swipe';
            }
        }
        return actions;

    }
    var carouselData = data;
    var activeTab = $('#' + creativeId + ' label[data-slide-to="' + data.carousel_index + '"]').get(0) ||
        $('#' + creativeId + ' label[data-idx="' + data.carousel_index + '"]').get(0);
    if (activeTab) {
        carouselData['value'] = activeTab.innerText.toLowerCase();
    }
    carouselData.carousel_index = carouselData.carousel_index + 1;
    carouselData.carousel_prev_index =  carouselData.carousel_prev_index + 1;
    var actions = getActionAndSubActionName();
    var eventdata = $.extend({}, carouselData, {
        'creative_id': creativeId,
        'action_category': 'user',
        'action_name': actions.action_name,
        'subaction_name': actions.subaction_name,
        'action_cause': actions.action_cause
    });
    eventToolbox.fireAction({
        'event_type': 'action_completed',
        'event_data': eventdata
    });
});



//////////////////
// WEBPACK FOOTER
// ./src/interlock/no-ui/engagement-handler/carousel-engagement-handler/carousel-engagement-handler.js
// module id = 431
// module chunks = 36